import createSvgIcon from "./utils/create_icon"

const PaperPlaneFill = createSvgIcon(<path d="M3.374 3.22a1 1 0 0 1 1.073-.114l16 8a1 1 0 0 1 0 1.788l-16 8a1 1 0 0 1-1.417-1.137l1.699-6.794A1 1 0 0 0 5 13h6a1 1 0 1 0 0-2H5a1 1 0 0 0-.271.037l-1.7-6.794a1 1 0 0 1 .345-1.023z" fill="currentColor" />, "PaperPlaneFill")
export default PaperPlaneFill
